import Icon from '../components/Icon';

const Error = Icon(
  'error',
  <>
    <path d="M12 7.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75M12 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
    <path
      fillRule="evenodd"
      d="M14.298 2.238a3.25 3.25 0 0 0-4.596 0L2.238 9.702a3.25 3.25 0 0 0 0 4.596l7.464 7.465a3.25 3.25 0 0 0 4.596 0l7.465-7.465a3.25 3.25 0 0 0 0-4.596zm-3.535 1.06a1.75 1.75 0 0 1 2.475 0l7.464 7.465a1.75 1.75 0 0 1 0 2.475l-7.465 7.464a1.75 1.75 0 0 1-2.474 0l-7.465-7.464a1.75 1.75 0 0 1 0-2.475z"
      clipRule="evenodd"
    />
  </>
);

export default Error;
